import script from "./ErrorAlertComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorAlertComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorAlertComponent.vue?vue&type=style&index=0&id=6d23a046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d23a046"]])

export default __exports__